export default {
  errors: {
    messageHeadline: 'This page isn’t loading right now',
    messageBody: 'We’re working on it.',
    retryButtonLabel: 'Retry',
    goToHomePageButtonLabel: 'Go to home',
  },
  loading: {
    titleText: 'You’re on your way to living better with money.',
  },
  shared: {
    skip: 'Skip',
  },
  walletProvisioning: {
    titleText: 'Your debit card is ready to use now',
    bodyText:
      'Just add it to your digital wallet and fund your account to start using it right away. Your physical card will arrive in about 2 weeks.',
  },
  onboardingOptionsScreen: {
    continue: 'Continue',
  },
  funding: {
    headline: 'Fund your account to get started',
    optionOne: {
      labelText: 'Fund instantly from debit card',
      tagText: 'Instant',
    },
    optionTwo: {
      labelText: 'Apply for a cash advance',
      tagOneText: 'Instant',
      tagTwoText: 'Quals apply',
    },
    optionThree: {
      labelText: 'Cash App, PayPal or Venmo',
      tagText: 'Instant',
    },
    optionFour: {
      labelText: 'Link bank account',
      tagText: '2-4 days',
    },
    optionFive: {
      labelText: 'Direct deposit',
      tagText: '14-30 days',
    },
  },
  intent: {
    headline: 'What excites you most about Varo?',
    optionOne: {
      labelText: 'No monthly fees bank account',
    },
    optionTwo: {
      labelText: 'Get paid up to 2 days earlier with direct deposit',
    },
    optionThree: {
      labelText: 'Borrow cash when you need it',
    },
    optionFour: {
      labelText: 'Build a cushion with high-yield savings',
    },
    optionFive: {
      labelText: 'Help with credit building',
    },
    optionSix: {
      labelText: 'Smarter financial insights',
    },
  },
  howDoYouGetPaid: {
    title: 'How do you get paid?',
    subtitle: 'If you have multiple jobs, pick the one that pays you the most.',
    directDeposit: 'Direct deposit',
    paymentApp: 'Payment app',
    cash: 'Cash',
    check: 'Check',
    anotherWay: 'Another way',
  },
  getPaidEarly: {
    headlineText: 'Get paid up to 2 days early¹',
    title: 'Enjoy early payday and more when you set up direct deposit.',
    listItem1:
      'Earn {{elevatedApy}} Annual Percentage Yield (APY) on your first {{compactBalanceCap}} and {{standardApy}} on the rest of your savings²',
    listItem2: 'Borrow up to $1,000 over time once you’re eligible³',
    listItem3: 'Set up your direct deposit within seconds',
    button: 'Set up direct deposit',
    skip: 'Skip',
    disclosure: 'See full disclosures',
  },
  depositCash: {
    howToDeposit: {
      heading: 'How to add cash at 90,000+ locations',
      description:
        'Add cash for free at 7,500 CVS® locations¹ or for a fee at other participating retailers. Hand your cash to the cashier and ask them to:',
      descriptionKroger:
        'Enjoy fee-free options at 7,500 CVS® and Kroger® locations¹ or for a fee at other participating retailers.',
      bullet: {
        one: 'Scan your barcode²',
        oneKroger: 'Ask the cashier to scan your barcode²',
        two: 'Or swipe your Varo Debit Card',
      },
    },
    disclosure: {
      first:
        '¹Available at all stand-alone CVS locations with a cashier in the US except those located within hospitals, on military bases, or in Target. You can add between $20-$500 per transaction. A retail service fee up to $4.95 and limits may apply for adding cash at other retail locations. ©Copyright 2026 ',
      second:
        '\u00B2Availability to add cash with a barcode varies by location.',
      third:
        'Service provided by Green Dot®. ©2026 Green Dot Corporation. All rights reserved. Green Dot Corporation NMLS #914924; Green Dot Bank NMLS #908739.',
      url: 'CVS.com.',
    },

    disclosureKroger: {
      first:
        '¹Available at all stand-alone CVS location with a cashier in the US, except for locations on military bases, within hospitals, or inside Target. Adding cash via barcode is free at the Kroger Family of Stores (excluding Harris Teeter stores) and a retail service fee of up to $4.95 may be charged for adding cash with card swipe. Transaction amounts must be between $20 and $500. Limits and a retail service fee of up to $4.95 may apply when adding cash at other retail locations. ©Copyright 2026 ',
      url: 'CVS.com.',
      second: '²Availability to add cash with a barcode varies by location.',
      third:
        'Service provided by Green Dot®. ©2026 Green Dot Corporation. All rights reserved. Green Dot Corporation NMLS #914924; Green Dot Bank NMLS #908739.',
    },
    buttons: {
      seeLocations: 'See locations near me',
    },
    skip: 'Skip',
  },
};
